module.exports = __webpack_public_path__ + "static/976ff2c5ec8d831388fd19ff891a2984.png";